/**
 * Procedural-horse colour palette. Body colours are silk-INDEPENDENT so the
 * jockey silks stay the only per-horse distinguishing element. A rich
 * chestnut keeps the racetrack feel consistent across all eight lanes.
 */
export const BODY = '#7a4a2a';
export const BODY_SHADE = '#4d2c14';
export const BODY_HIGHLIGHT = '#a06a40';
export const BODY_DARK = '#1a0e07';
export const HOOF = '#0d0703';
